import {formHandler} from '@/app/js/helpers/forms'
import {sendTarget} from '@/app/js/yandex/target'

export function handleForms() {
  const FORM_SELECTOR = '.js-ajax-form'

  Array.from(document.querySelectorAll(FORM_SELECTOR)).forEach(function (form) {
    formHandler({
      form,
      onFatalError() {},
      onValidationError(errors) {
        const phoneFirstNumErrorEl = document.querySelector('.error-phone-first-num')
        if (phoneFirstNumErrorEl) {
          phoneFirstNumErrorEl.remove()
        }

        if (errors.find(error => error === 'user_phone')) {
          const telEl = form.querySelector('input[type="tel"]')
          telEl.style.border = '1px solid red'
          telEl.parentNode.style.position = 'relative'

          const divEl = document.createElement('div')
          divEl.textContent = 'Номер не может начинаться с цифры 8 или 7'
          divEl.classList.add('error-phone-first-num')

          telEl.parentNode.appendChild(divEl)

          setTimeout(() => {
            divEl.remove()
          }, 5000)
        }
      },
      onSuccess(html) {
        form.innerHTML = html
        if (form.dataset.yandexGoal) {
          window.yaCounter4175221.reachGoal(form.dataset.yandexGoal)
        }
        sendTarget()
      }
    })
  })
}
